export default __webpack_public_path__ + "static/media/quickLogo.fccc1550.png";